import React from 'react'
import { TraceSummarySingleView } from '../domain/TraceSummary'
import { ContextLinks, ContextLinksTypes } from './ContextLinks'
import moment from 'moment/moment'

interface Props {
    trace: TraceSummarySingleView
}

export class TraceContextLinks extends React.PureComponent<Props> {
    public render() {
        const { trace } = this.props

        if (!trace.operation) {
            return null
        }

        const links = [
            {
                type: 'monitoring' as ContextLinksTypes,
                route: 'XhprofProfilerBundle.Transaction.show',
                params: {
                    operation: trace.operation.id,
                    s: trace.service,
                    env: trace.environment,
                    m: 60,
                    ts: moment
                        .utc(trace.measureDate.date)
                        .subtract({ minutes: 30 })
                        .format('YYYY-MM-DD HH:mm'),
                },
                tooltip: 'Show Performance data for this Transaction at the time of this Trace.',
            },
            {
                type: 'history' as ContextLinksTypes,
                route: 'XhprofProfilerBundle.History.operationHistory',
                params: {
                    operation: trace.operation.id,
                    granularity: 'month',
                    date: moment().format('YYYY-MM-DD'),
                    s: trace.service,
                    env: trace.environment,
                },
                tooltip: 'Show historical data for this Transaction of this trace.',
            },
        ]

        return <ContextLinks links={links} />
    }
}
